import logo from "@/assets/hiredcoach-logo.svg";
import BrandWordmark from "@/components/marketing/BrandWordmark";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

interface PublicSiteLayoutProps {
  children: ReactNode;
}

const PublicSiteLayout = ({ children }: PublicSiteLayoutProps) => {
  const { user } = useAuth();
  const homeTarget = user ? "/dashboard" : "/";

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <nav className="flex justify-between items-center">
            <Link to={homeTarget} className="flex items-center min-w-0 flex-shrink hover:opacity-90 transition-opacity">
              <img src={logo} alt="HiredCoach Logo" className="w-8 h-8 sm:w-10 sm:h-10 mr-1 sm:mr-2 flex-shrink-0" />
              <span className="font-bold text-lg sm:text-xl truncate">
                <span style={{ color: "#4f9ecb" }}>Hired</span>
                <span style={{ color: "#334763" }}>Coach</span>
              </span>
            </Link>
            <div className="flex gap-1 sm:gap-2 md:gap-4 flex-shrink-0">
              <Button
                variant="ghost"
                className="text-sm sm:text-base px-2 sm:px-4 border border-[#4f9ecb]/40 bg-[#edf5fb] hover:bg-[#dcecf8] hover:text-[#243247] font-semibold"
                asChild
              >
                <Link to="/public-learn">
                  <span style={{ color: "#4f9ecb", fontWeight: 700 }}>Coach</span>
                  <span style={{ color: "#334763", fontWeight: 700 }}>U</span>
                </Link>
              </Button>
              <Button variant="ghost" className="text-gray-600 bg-gray-100 hover:bg-gray-200 hover:text-gray-900 text-sm sm:text-base px-2 sm:px-4" asChild>
                <Link to="/login">Sign In</Link>
              </Button>
              <Button style={{ backgroundColor: "#4f9ecb" }} className="text-white hover:opacity-90 text-sm sm:text-base px-2 sm:px-4" asChild>
                <Link to="/register">Sign Up</Link>
              </Button>
            </div>
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="bg-gray-900 text-white py-12 px-6">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div>
              <div className="flex items-center mb-4">
                <img src={logo} alt="HiredCoach Logo" className="w-16 h-16 mr-2" />
                <span className="font-bold text-xl">
                  <span style={{ color: "#4f9ecb" }}>Hired</span>
                  <span className="text-white">Coach</span>
                </span>
              </div>
            </div>

            <div>
              <ul className="space-y-2">
                <li>
                  <Link to="/#features" className="text-gray-400 hover:text-white">Features</Link>
                </li>
              </ul>
            </div>

            <div>
              <ul className="space-y-2">
                <li>
                  <Link to="/#pricing" className="text-gray-400 hover:text-white">Pricing</Link>
                </li>
                <li>
                  <Link to="/agreements" className="text-gray-400 hover:text-white">Terms of Service and Policies</Link>
                </li>
              </ul>
            </div>

            <div>
              <ul className="space-y-2">
                <li>
                  <Link to="/contact" className="text-gray-400 hover:text-white">Contact</Link>
                </li>
                <li>
                  <Link to="/public-learn" className="text-gray-400 hover:text-white">
                    <span style={{ color: "#4f9ecb", fontWeight: 700 }}>Coach</span>
                    <span style={{ color: "#334763", fontWeight: 700 }}>U</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 text-center">
            <p className="text-gray-500">
              &copy; {new Date().getFullYear()}{" "}
              <BrandWordmark
                hiredClassName="font-bold text-[#4f9ecb]"
                coachClassName="font-bold text-white"
              />{" "}
              . All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicSiteLayout;
